import React from "react";
import styled, { css } from "styled-components";
import { NavLink } from "react-router-dom";
import Close from "../Icons/Close";

import flags from "../../data/flags.json";

const Header = ({ handleClose, country, contributions, mode }) => {
    const iso = flags[country];

    return <Container>
        <Button onClick={ handleClose }>
            <Close mode={ mode } />
        </Button>

        <MetaWrapper>
            <SelectedCountry>
            { country   
                ? <img 
                    src={ require(`../../assets/flags/${ iso }.png`)}
                    alt={ `${ country } flag`} />  
                : null }
                <span>{ country }</span>
            </SelectedCountry>
            <Contributions>✅ { contributions }</Contributions>
        </MetaWrapper>
        
        <Menu mode={ mode }>
            <NavLink activeClassName="active" exact to="/"><li>General</li></NavLink> 
            <NavLink activeClassName="active" to="/contributors"><li>Top 100 contributors</li></NavLink>
        </Menu> 
    </Container> 
}

const Container = styled.div`
    position: relative;
    padding-top: 12px;
`

const Menu = styled.ul`
    display: flex;
    align-items: center;

    .active {
        border-bottom: 4px solid black;
        ${ props => props.mode === "dark" && css`border-bottom: 4px solid white;` }
    }

    a {
        width: 50%;
        padding: 12px 0;
        font-size: 12px;
        font-weight: bold;
        text-align: center;
        cursor: pointer;
        color: inherit;
        text-decoration: none;
    }
`

const MetaWrapper = styled.div`
    display: flex;
    align-items: center;
    justify-content: space-between;
`

const Contributions = styled.p`
    font-size: 16px;
    padding: 24px 0;
`

const Button = styled.button`
    border: none;
    background: transparent;
    cursor: pointer;
    position: absolute;
    top: 0;
    right: 0;
`

const SelectedCountry = styled.h3`
    font-size: 24px;
    text-align: center;
    text-transform: capitalize;
    display: flex;
    align-items: center;

    img {
        margin-right: 12px;
    }
`

export default Header;